import React from 'react';
import { Flex, FlexBehavior, ButtonColor, ButtonVariant, ButtonTextTransform, ModalSize } from 'react-magma-dom';
import {
  StyledWelcomeImage,
  StyledFlexWelcomeText,
  StyledWelcomeHeaderText,
  StyledWelcomeTextP,
  StyledWelcomeTextPSub,
  StyledWelcomeTextL,
  StyledModal,
  StyledWelcomeLeftImage,
  StyledWelcomeTextButton,
  StyledButton,
} from '../../../components/Styled/StyledWelcomeModal';
import girl from '../../../assets/girl.png';
import { navigate } from '@reach/router';
import { useMediaQuery } from 'react-responsive';

export const WelcomeModal = (): JSX.Element => {
  const [showModal, setShowModal] = React.useState(true);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 });
  const modalSize = isMobile ? ModalSize.small : isTablet ? ModalSize.medium : ModalSize.large;

  const handleWelcomeClose = () => {
    setShowModal(false);
    localStorage.setItem('firstTime', 'false');
  };

  const handleLessonsRedirect = () => {
    handleWelcomeClose();
    navigate(`/lessons`);
  };

  const handleExemplarsRedirect = () => {
    handleWelcomeClose();
    navigate(`/exemplars`);
  };

  const handleSkillsRedirect = () => {
    handleWelcomeClose();
    navigate(`/professional/writing-skills-and-conventions`);
  };

  const handleAboutRedirect = () => {
    handleWelcomeClose();
    navigate(`/professional/about-pm-writing`);
  };

  return (
    <StyledModal
      testId="welcome-modal"
      onClose={handleWelcomeClose}
      isOpen={showModal}
      isBackgroundClickDisabled
      size={modalSize}
    >
      <Flex behavior={FlexBehavior.container} spacing={0}>
        <StyledWelcomeLeftImage behavior={FlexBehavior.item} xs={12} md={4}>
          <StyledWelcomeImage src={girl as string} alt="girl" />
        </StyledWelcomeLeftImage>
        <StyledFlexWelcomeText behavior={FlexBehavior.item} xs={12} md={8}>
          <StyledWelcomeHeaderText>Welcome!</StyledWelcomeHeaderText>
          <StyledWelcomeTextP>
            The PM Writing Teacher Portal is a comprehensive suite of teacher resources that provides full support for
            the exploration and development of writing skills for all your students.
          </StyledWelcomeTextP>
          <br />
          <StyledWelcomeTextL>
            <StyledWelcomeTextButton
              onClick={handleExemplarsRedirect}
              color={ButtonColor.primary}
              variant={ButtonVariant.link}
              textTransform={ButtonTextTransform.none}
            >
              View Digital Exemplars →
            </StyledWelcomeTextButton>
            <StyledWelcomeTextPSub>Create new texts and explore key language features</StyledWelcomeTextPSub>
            <br />
            <StyledWelcomeTextButton
              onClick={handleSkillsRedirect}
              color={ButtonColor.primary}
              variant={ButtonVariant.link}
              textTransform={ButtonTextTransform.none}
            >
              View Teacher Support Videos →
            </StyledWelcomeTextButton>
            <StyledWelcomeTextPSub>Refresh your knowledge around the teaching of writing</StyledWelcomeTextPSub>
            <br />
            <StyledWelcomeTextButton
              onClick={handleLessonsRedirect}
              color={ButtonColor.primary}
              variant={ButtonVariant.link}
              textTransform={ButtonTextTransform.none}
            >
              View Lesson Plans →
            </StyledWelcomeTextButton>
            <StyledWelcomeTextPSub>
              Cater to a range of student abilities using differentiated lesson plans
            </StyledWelcomeTextPSub>
            <br />
            <StyledWelcomeTextButton
              onClick={handleAboutRedirect}
              color={ButtonColor.primary}
              variant={ButtonVariant.link}
              textTransform={ButtonTextTransform.none}
            >
              How to best integrate PM Writing →
            </StyledWelcomeTextButton>
            <StyledWelcomeTextPSub>
              Find out how to best integrate PM Writing into your classroom through the professional learning page{' '}
            </StyledWelcomeTextPSub>
            <br />
          </StyledWelcomeTextL>
          <p>
            <StyledButton onClick={handleWelcomeClose} color={ButtonColor.primary}>
              Let me explore!
            </StyledButton>
          </p>
        </StyledFlexWelcomeText>
      </Flex>
    </StyledModal>
  );
};
